import infoLockedImg from "../../assets/images/noMetabolicScore.webp";

const NoMetabolicScore: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen p-6 text-center">
      <div className="relative mb-6">
        <div className="relative z-10 w-screen flex items-center justify-center">
          <img
            src={infoLockedImg}
            alt="Info Locked"
            className="px-3"
            width={200}
            height={200}
            style={{ width: "auto", height: "auto" }}
          />
        </div>
      </div>

      <h1 className="text-3xl font-bold text-gray-800 mb-4">
        Metabolic Score Not Available Yet!
      </h1>
      <p className="text-md text-gray-600 max-w-md px-1">
        The patient is yet to complete their onboarding journey. Once they’re
        done, we’ll calculate and display their Metabolic Score here—so you can
        get a better view of their health profile.
      </p>
    </div>
  );
};

export default NoMetabolicScore;
